import { render, staticRenderFns } from "./tours.vue?vue&type=template&id=67e7ddc8&scoped=true&"
import script from "./tours.vue?vue&type=script&lang=js&"
export * from "./tours.vue?vue&type=script&lang=js&"
import style0 from "./tours.vue?vue&type=style&index=0&id=67e7ddc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e7ddc8",
  null
  
)

export default component.exports